import { message } from "antd";
import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector, RootStateOrAny } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { User } from "../../../core/entities/user";
import { clearSpecificRequest } from "../../../redux/request/action";
import {
  clearUserValues,
  fetchUserById,
  updateUserRequest,
} from "../../../redux/user/action";
import {
  FETCH_USER_BY_ID,
  UPDATE_USER_REQUEST,
} from "../../../redux/user/actionType";
import { Loader } from "../../atoms/Loader";
import { LoaderWrapper } from "../../templates/UpdateUser/elements";
import UpdateUserPage from "./UpdateUserPage";
import { Alert } from "../../atoms/Alert";

const UpdateUserPageContainer = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const navigationParams: { id: string } = useParams();
  const { id } = navigationParams;

  const dispatchUpdateUser = useCallback(
    (id: string, params: Partial<User>, updateType: string) =>
      dispatch(updateUserRequest(id, params, updateType)),
    [dispatch]
  );

  const request = useSelector(
    (state: RootStateOrAny) => state.requestStore?.[FETCH_USER_BY_ID]
  );

  const isUpdating = useSelector(
    (state: RootStateOrAny) => state.user.isUpdating
  );

  const updateSuccessful = useSelector(
    (state: RootStateOrAny) => state.user.updateSuccessful
  );

  const updateType = useSelector(
    (state: RootStateOrAny) => state.user.updateType
  );

  const updateRequest = useSelector(
    (state: RootStateOrAny) => state.requestStore?.[UPDATE_USER_REQUEST]
  );

  const user = useSelector((state: RootStateOrAny) => state.user.user);
  const currentUser = useSelector((state: RootStateOrAny) => state.auth.user);

  useEffect(() => {
    dispatch(fetchUserById(id));

    return () => {
      dispatch(clearUserValues());
      dispatch(clearSpecificRequest(FETCH_USER_BY_ID));
      dispatch(clearSpecificRequest(UPDATE_USER_REQUEST));
    };
  }, [dispatch, id]);

  useEffect(() => {
    if (updateType === "basicDetails" && !isUpdating && updateSuccessful) {
      message.config({ duration: 2 });
      message.success("User successfully updated");
      return history.push("/admin/users");
    }
  }, [history, isUpdating, updateSuccessful, updateType]);

  return (
    <>
      {request?.isLoading || isUpdating ? (
        <LoaderWrapper>
          <Loader />
        </LoaderWrapper>
      ) : (
        <UpdateUserPage
          user={user}
          onUpdateUser={dispatchUpdateUser}
          userId={id}
          updateSucceeded={updateSuccessful}
          currentUser={currentUser}
        />
      )}
      {updateRequest?.error && (
        <Alert type="error" message={updateRequest?.error} showIcon />
      )}
      {!updateRequest?.error && updateType && !isUpdating && (
        <Alert
          type="success"
          message={`${
            updateType === "accountStatus"
              ? "Account status"
              : updateType === "password" && "Password"
          } successfully updated`}
          showIcon
        />
      )}
    </>
  );
};

export default UpdateUserPageContainer;
